import script from "./UiHorizontalScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiHorizontalScroll.vue?vue&type=script&setup=true&lang=ts"

import "./UiHorizontalScroll.vue?vue&type=style&index=0&id=463a1886&lang=css"

const __exports__ = script;

export default __exports__